module.exports = __webpack_public_path__ + "media/product/cat-05-7d03ffb3.png";